import { render, staticRenderFns } from "./coreValues_add.vue?vue&type=template&id=8f1c1f4c&scoped=true"
import script from "./coreValues_add.vue?vue&type=script&lang=js"
export * from "./coreValues_add.vue?vue&type=script&lang=js"
import style0 from "./coreValues_add.vue?vue&type=style&index=0&id=8f1c1f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1c1f4c",
  null
  
)

export default component.exports